import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { FaCar } from 'react-icons/fa6';
import { LuPhone } from 'react-icons/lu'
import { MdCategory, MdDirectionsCar, MdLocationOn, MdMoney, MdOutlineAirlineSeatReclineNormal, MdSettings } from 'react-icons/md'
import { Range } from 'react-range';
import Select from 'react-select';

const SectionSearchResultList = () => {
    const vehicles = [
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
        { _id: 1, image: "design/images/Lexus_CT_200h.png" },
    ]

    return (
        <div className="container-fluid" style={{ padding: "20px 10px 150px 10px" }}>
            <div className="container">
                <Row style={{ minHeight: "400px" }}> {/* Hauteur minimale pour activer le défilement */}
                    {/* Colonne Gauche (Sticky) */}
                    <Col md={4}>
                        <div className="shadow-sm"
                            style={{
                                position: "sticky",
                                top: "110px", // Distance depuis le haut
                                padding: "10px 10px 50px 10px",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                
                            }}
                        >
                            <Row>
                                <Col md={6}>
                                    <div className="mt-3">
                                        <div><label style={{ color: "#737373" }}>Moteur</label></div>
                                        <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                            <MdSettings color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                            <div style={{ width: "100%" }}>
                                                <Select options={[{ value: "", label: "Option 1" }]} value={{ value: "", label: "" }} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mt-3">
                                        <div><label style={{ color: "#737373" }}>Marques</label></div>
                                        <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                            <MdDirectionsCar color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                            <div style={{ width: "100%" }} >
                                                <Select options={[{ value: "", label: "Option 1" }]} value={{ value: "", label: "" }} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mt-3">
                                        <div><label style={{ color: "#737373" }}>Modèle</label></div>
                                        <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                            <FaCar color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                            <div style={{ width: "100%" }}>
                                                <Select options={[{ value: "", label: "Option 1" }]} value={{ value: "", label: "" }} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mt-3">
                                        <div><label style={{ color: "#737373" }}>Catégorie</label></div>
                                        <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                            <MdCategory color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                            <div style={{ width: "100%" }} >
                                                <Select options={[{ value: "", label: "Option 1" }]} value={{ value: "", label: "" }} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="mt-3">
                                        <div><label style={{ color: "#737373" }}>Nombre de sièges</label></div>
                                        <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                            <MdOutlineAirlineSeatReclineNormal color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                            <div style={{ width: "100%" }}>
                                                <input type="number" className="text-dark" style={{ width: "100%", background: "white", border: "1px white solid", padding: "2px 10px 2px 2px", borderRadius: "30px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                {/* Filtre par Prix */}
                                <Col md={12}>
                                    <div className="mt-4">
                                        <div><label style={{ color: "#737373" }}>Filtrer par prix</label></div>
                                        <div
                                            className=""
                                            style={{
                                                borderRadius: "30px",
                                                width: "100%",
                                                padding: "10px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {/*<MdMoney color={"#D9D9D9"} size={30} style={{ marginRight: "10px" }} /> */}
                                            <div style={{ width: "100%" }}>
                                                <Range
                                                    step={100}
                                                    min={0}
                                                    max={10000}
                                                    values={[0, 10000]} // Valeurs initiales (min et max)
                                                    onChange={(values) => {
                                                        console.log("Prix sélectionné :", values);
                                                        // Vous pouvez gérer les states ici si nécessaire
                                                    }}
                                                    renderTrack={({ props, children }) => (
                                                        <div
                                                            {...props}
                                                            style={{
                                                                height: '6px',
                                                                width: '100%',
                                                                backgroundColor: '#ddd',
                                                                borderRadius: '3px',
                                                                alignSelf: 'center',
                                                            }}
                                                        >
                                                            {children}
                                                        </div>
                                                    )}
                                                    renderThumb={({ props }) => (
                                                        <div
                                                            {...props}
                                                            style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                backgroundColor: '#D2D2D2',
                                                                borderRadius: '50%',
                                                                border: '2px solid #fff',
                                                                boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
                                                                cursor: 'grab',
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Filtre par Kilométrage */}
                                <Col md={12}>
                                    <div className="mt-4">
                                        <div><label style={{ color: "#737373" }}>Filtrer par kilométrage</label></div>
                                        <div
                                            className=""
                                            style={{
                                                borderRadius: "30px",
                                                width: "100%",
                                                padding: "10px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {
                                                /*<MdSettings color={"#D9D9D9"} size={30} style={{ marginRight: "10px" }} /> */
                                            }
                                            <div style={{ width: "100%" }}>
                                                <Range
                                                    step={1000}
                                                    min={0}
                                                    max={100000}
                                                    values={[0, 100000]} // Valeurs initiales (min et max)
                                                    onChange={(values) => {
                                                        console.log("Kilométrage sélectionné :", values);
                                                        // Vous pouvez gérer les states ici si nécessaire
                                                    }}
                                                    renderTrack={({ props, children }) => (
                                                        <div
                                                            {...props}
                                                            style={{
                                                                height: '6px',
                                                                width: '100%',
                                                                backgroundColor: '#ddd',
                                                                borderRadius: '3px',
                                                                alignSelf: 'center',
                                                            }}
                                                        >
                                                            {children}
                                                        </div>
                                                    )}
                                                    renderThumb={({ props }) => (
                                                        <div
                                                            {...props}
                                                            style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                backgroundColor: '#D2D2D2',
                                                                borderRadius: '50%',
                                                                border: '2px solid #fff',
                                                                boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
                                                                cursor: 'grab',
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={8}>
                        <Row>
                            {
                                vehicles && vehicles.length > 0 &&
                                vehicles.map((item) => {
                                    return (
                                        <Col md={6} >
                                            <div className="" style={{ width: "100%" }}>
                                                <div className="shadow-sm rounded-lg" style={{ margin: "10px", width: "100%", overflow: "hidden", }}>
                                                    <div style={{ background: "#F2F2F2", width: "100%" }}>
                                                        <img src={item.image} style={{ height: "180px", width: "100%" }} />
                                                    </div>
                                                    <div style={{ background: "white", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                                                        <div><h6 className="text-dark">Lexus CT200H</h6></div>
                                                        <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                                            <div>
                                                                <span style={{ fontWeight: "bold", fontSize: "25px" }} className="font-bold"> 120 </span>
                                                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>DZD</span>
                                                                <span style={{ color: "#A6A6A6", fontSize: "12px" }}>/Jour</span>
                                                            </div>
                                                            <div>
                                                                <span style={{ color: "#A6A6A6", fontSize: "12px" }}> <MdLocationOn /> Algerie</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <Button type="button" style={{ padding: "10px 5px 10px 5px", color: "white", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center" }} variant="white" className="w-100 border-dark">
                                                                <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                                                                    <div className="p-1">
                                                                        {/*<LuPhone /> */}
                                                                    </div> <div className="p-1"><span className="text-center text-dark"> Voire l{"'"}offre </span> </div>
                                                                </div>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default SectionSearchResultList
